export default __webpack_public_path__ + "static/media/CANDIDATE_CONSIDER.f4d417a1.png";